import { useCallback } from 'react';
import { DealPlanCompanyAssigneeTypename, DealPlanSellerTypename } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanPortalRpc';
import { useSellerLogoUrl } from './useSellerLogoUrl';
import { useAvatarData } from '../contexts/AvatarsContext';
export function useOwnerSrc() {
  const sellerSrc = useSellerLogoUrl();
  const avatarData = useAvatarData();
  return useCallback(owner => {
    var _avatarData$results$f, _companies$find, _companies$;
    if (owner.__typename === DealPlanSellerTypename) return sellerSrc;
    const companies = (_avatarData$results$f = avatarData === null || avatarData === void 0 ? void 0 : avatarData.results.filter(r => r.type === 'COMPANY')) !== null && _avatarData$results$f !== void 0 ? _avatarData$results$f : [];
    if (owner.__typename === DealPlanCompanyAssigneeTypename) return (_companies$find = companies.find(r => r.id === owner.companyId)) === null || _companies$find === void 0 ? void 0 : _companies$find.avatarUrl;
    return (_companies$ = companies[0]) === null || _companies$ === void 0 ? void 0 : _companies$.avatarUrl;
  }, [sellerSrc, avatarData]);
}